import React from 'react'
import "../../src/styles/Loader.scss"
const Loader = () => {
  return (
    <div className='loader_parent'>
      <div class="loader"></div>
    </div>
  )
}

export default Loader
